if($('#category-header').length){
    function mhstrankovani(){
        var findnumber = $('#category-header>div strong').last().text()
        var productslength = $('#products .product').length
        var pocetstran = $('.pagination strong.current').text()
        var vypocet = pocetstran*productslength
        var vypocetprvnihocisla = vypocet-productslength
        var vypocetprvnihocisla = vypocetprvnihocisla+1
        if($('.pagination strong.current').text() == 1){
            var vypocetprvnihocisla = 1
        }
        if($('.pagination a.next').length == 0){
            var vypocet = findnumber
            var vypocetprvnihocisla = findnumber-productslength+1
        }
        if($('.pagination a.prev').length == 0){
            $('.pagination').addClass('noleft')
        }
        $('#category-header>div').html(zobrazuji+' ' +vypocetprvnihocisla+' - <span class="vypocet">'+vypocet+'</span> '+z+' <strong>'+findnumber+'</strong>');
        document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
            var vypocetpozobrazeni = $('#products .product').length
            $('#category-header>div').html(zobrazuji+' '+vypocetpozobrazeni+' '+z+' <strong>'+findnumber+'</strong>');
        });
    }
    $(document).ready(function(){
        mhstrankovani();
        $('#category-header>div').show();
    })
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        mhstrankovani();
        $('#category-header>div').show();
    });
    
}